import React, { lazy } from 'react';
import Loadable from 'components/loading/Loadable';
import { NewsBoardApi } from 'api/community/NewsBoardApi';
import { NewsProvider } from './context';

const List = Loadable(lazy(() => import('./list')));
const Create = Loadable(lazy(() => import('./create')));
const Edit = Loadable(lazy(() => import('./edit')));

const NewsBoardConfig = {
    routes: [
        {
            path: 'news',
            children: [
                {
                    path: '',
                    element: <NewsProvider><List /></NewsProvider>
                },
                {
                    path: 'create',
                    element: <NewsProvider><Create /></NewsProvider>
                },
                {
                    path: 'modify/:code',
                    element: <NewsProvider><Edit /></NewsProvider>
                }
            ]
        }
    ],
    API: NewsBoardApi
};

export default NewsBoardConfig;
